'use strict';

/* eslint-disable max-lines-per-function, max-params */

angular.module('webAgro1App').controller('GlebaCtrl', function(
  $location, $scope, $rootScope, $routeParams, $timeout,
  DrawPolygonsService, GlebasService, Flash, LoadingService, MessagesService, PropriedadesService, CommonHTTPService
) {
  $scope.idMapContentGleba = ID_MAP_GLEBA;
  const textType = /kml.*/;

  const error = function() {
    Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
    $location.path('/glebas');
  };

  const initializeMap = function(gleba) {
    $timeout(function() {
      GlebasService.getMapGleba($scope.idMapContentGleba, gleba).then(function(result) {
        $scope.glebaMapa = result;
      })
        .finally(LoadingService.hideLoading);
    }, 500);
  };

  $scope.resetKml = function() {
    $scope.glebaMapa = null;
    $scope.kmlFile = null;
    angular.element('input[type="file"]').val(null);
    if ($scope.gleba) {
      $scope.gleba.arquivo_kml = null;
      $scope.gleba.tem_kml = false;
    }
  };

  $scope.excluirMapa = function() {
    if (document.getElementById($scope.idMapContentGleba)) {
      document.getElementById($scope.idMapContentGleba).innerHTML = '';
    }

    $scope.resetKml();
  };

  const loadAreasDemarcadas = function() {
    return DrawPolygonsService.list({
      tipo: {
        id: 'geral'
      },
      propriedade: $scope.gleba.propriedade
    }).then(function(result) {
      $scope.areasDemarcadas = result.data;
    });
  };

  const initialize = function() {
    LoadingService.showLoading();
    $scope.excluirMapa();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.glebas.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        GlebasService.get($routeParams.id).then(function(data) {
          $scope.gleba = data.data || {};
          if (!$scope.gleba.id) {
            error();
          } else if ($scope.gleba.tem_kml) {
            initializeMap($scope.gleba);
          } else {
            LoadingService.hideLoading();
          }
        }, error);
      } else {
        $scope.gleba = {};
        PropriedadesService.all().then(function(propriedades) {
          $scope.propriedadesGlebas = propriedades.data || [];
        })
          .catch($rootScope.errorRootInitialize)
          .finally(LoadingService.hideLoading);
      }
    });
  };

  initialize();

  $scope.changePropriedade = function() {
    LoadingService.showLoading();
    loadAreasDemarcadas()
      .catch($rootScope.errorRootInitialize)
      .finally(LoadingService.hideLoading);
  };

  const loadKmlContent = function(content) {
    return GlebasService.getCoordinatesFromKmlFile(content).then(function(data) {
      const result = {
        coordinates: data.data || []
      };

      initializeMap(result);
      $scope.gleba.arquivo_kml = content;
      $scope.gleba.tem_kml = true;
      if (!result.coordinates.length) {
        $scope.resetKml();
        LoadingService.hideLoading();
        MessagesService.alert('Nenhuma coordenada encontrada no arquivo.');
      }
    }, function() {
      $scope.resetKml();
      error();
    });
  };

  $scope.changeFile = function() {
    const errorMessage = function() {
      LoadingService.hideLoading();
      MessagesService.alert('Não foi possível carregar o arquivo');
    };

    const setArquivoKmlToMap = function() {
      LoadingService.showLoading();
      $scope.areaDemarcada = null;

      const fileReader = new FileReader();
      fileReader.onload = function(fileData) {
        const resultFileData = fileData.target.result;
        loadKmlContent(resultFileData);
      };

      fileReader.readAsText($scope.kmlFile);
    };

    // No MacOS, mesmo utilizando chrome, o type retornado é uma string vazia :(
    if ($scope.kmlFile && ($scope.kmlFile.type === '' || $scope.kmlFile.type.match(textType))) {
      setArquivoKmlToMap();
    } else {
      $scope.resetKml();
      errorMessage();
    }
  };

  $scope.goToIndex = function() {
    $location.path('/glebas');
  };

  $scope.goToShow = function() {
    $location.path(`/glebas/${ ($scope.gleba || {}).id}`);
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    if ($scope.gleba.area_propria === $scope.gleba.area_arrendada && $scope.gleba.area_propria === 0) {
      MessagesService.alert('A área própria e a área arrendada não podem ser iguais a 0!');
      return;
    }

    LoadingService.showLoading();
    GlebasService.save($scope.gleba).then(function(result) {
      $scope.gleba.id = result.data.id;
      // recarrega todas as propriedades e coordenadas
      return PropriedadesService.list();
    })
      .then(function(propriedades) {
        $rootScope.propriedades = propriedades.data;
        // reseta a propriedade selecionada atualmente
        // se houver
        if ($rootScope.currentPropriedade) {
          $rootScope.setPropriedade($rootScope.currentPropriedade.id);
        }

        $scope.goToShow();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      })
      .catch(function(e) {
        if (CommonHTTPService.isBadRequest(e.status) && e.data) {
          MessagesService.alert(Object.values(e.data).join('<br>'));
        } else {
          MessagesService.alert(FALHA_AO_SALVAR_REGISTRO.msg);
        }
      })
      .finally(LoadingService.hideLoading);
  };


  $scope.loadAreaDemarcada = function(areaDemarcada) {
    LoadingService.showLoading();
    DrawPolygonsService.getKmlContent(areaDemarcada.id).then(function(result) {
      const temArea = $scope.gleba.area_propria || $scope.gleba.area_arrendada;
      if (!temArea) {
        $scope.gleba.area_propria = +areaDemarcada.area / TAXA_M2_HA;
        $scope.gleba.area_arrendada = 0;
      }
      return loadKmlContent(result.data);
    })
      .catch(function(errorKmlContent) {
        console.error('Falha ao carregar KML', errorKmlContent);
        MessagesService.alert('Não foi possível carregar a demarcação.');
      })
      .finally(LoadingService.hideLoading);
  };
});
